import React from "react";
import clsx from "clsx";
import { Card, CardBody, CardHeader } from "reactstrap";
import { SynchronizationReportRecordsTable } from "./SynchronizationReportRecordsTable";
import { PropertiesTable } from "../../components/PropertiesTable";

export function SynchronizationReportCard({ title, value, translations })
{
    const translatedTitle = translations?.headers?.[title] ?? title;
    const element =
    <Card>
        <CardHeader>
            <i className={clsx('fa fa-align-justify')}></i>
            <span>{translatedTitle}</span>
        </CardHeader>
        <CardBody>
            {Array.isArray(value) ? <SynchronizationReportRecordsTable items={value} /> : <PropertiesTable title={title} properties={value} translations={translations} />}
        </CardBody>
    </Card>;
    return element;
}